var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main bgF5F5F5",style:('height:'+_vm.height+'px')},[_c('courseListLeft',{on:{"setParams":_vm.getParams}}),_c('courseListRight',{attrs:{"parData":_vm.getParamsList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }